<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
    <v-card-title class="headline">Available Times</v-card-title>

    <v-card-text>

         <m-edit-message-patterns-compact
            label="Auto reply when not available"
            v-model="dnd_auto_response_message_patterns"
            context="dnd-auto-response"
            style="margin-bottom: 15px"
        />
        

        Monday
        <m-dnd-intervals
            v-model="dnd_monday"
            offer_weekday_copy
            offer_copy_all_days
            v-on:copy_weekday="copyWeekday(dnd_monday)"
            v-on:copy_all="copyAll(dnd_monday)"
        />

        Tuesday
        <m-dnd-intervals
            v-model="dnd_tuesday"
            offer_weekday_copy
            offer_copy_all_days
            v-on:copy_weekday="copyWeekday(dnd_tuesday)"
            v-on:copy_all="copyAll(dnd_tuesday)"
        />

        Wednesday
        <m-dnd-intervals
            v-model="dnd_wednesday"
            offer_weekday_copy
            offer_copy_all_days
            v-on:copy_weekday="copyWeekday(dnd_wednesday)"
            v-on:copy_all="copyAll(dnd_wednesday)"
        />

        Thursday
        <m-dnd-intervals
            v-model="dnd_thursday"
            offer_weekday_copy
            offer_copy_all_days
            v-on:copy_weekday="copyWeekday(dnd_thursday)"
            v-on:copy_all="copyAll(dnd_thursday)"
        />

        Friday
        <m-dnd-intervals
            v-model="dnd_friday"
            offer_weekday_copy
            offer_copy_all_days
            v-on:copy_weekday="copyWeekday(dnd_friday)"
            v-on:copy_all="copyAll(dnd_friday)"
        />

        Saturday
        <m-dnd-intervals
            v-model="dnd_saturday"
            offer_weekend_copy
            offer_copy_all_days
            v-on:copy_weekend="copyWeekend(dnd_saturday)"
            v-on:copy_all="copyAll(dnd_saturday)"
        />

        Sunday
        <m-dnd-intervals
            v-model="dnd_sunday"
            offer_weekend_copy
            offer_copy_all_days
            v-on:copy_weekend="copyWeekend(dnd_sunday)"
            v-on:copy_all="copyAll(dnd_sunday)"
        />

        <div
            v-for="(custom_dnd,index) in custom_dnd_settings"
            :key="index"
        >
        {{prettyDateRange(custom_dnd)}} 
        <m-dnd-intervals
            v-model="custom_dnd.available_intervals"
            :dnd_auto_response_message_patterns="custom_dnd.dnd_auto_response_message_patterns"
            offer_delete
            offer_custom_auto_reply
            v-on:delete="deleteCustomDND(index)"
            v-on:input-dnd-auto-response="setCustomAutoReply(index,$event)"
            v-on:edit-dates="onEditDates(index)"
        />
        </div>

        <v-row>
            <v-col>
            </v-col>

            <v-col
                class='flex-grow-0'
            >
                <v-btn 
                    class="mx-2" fab dark small color="primary"
                    v-on:click="onAddDNDDate"
                >
                    <v-icon dark>mdi-plus</v-icon>
                </v-btn>
            </v-col>
        </v-row>
                
    </v-card-text>


    <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
            color="gray darken-1"
            text
            @click="dialog = false"
        >
        Cancel
        </v-btn>

        <v-btn
            color="primary darken-1"
            text
            @click="onOk"
        >
        Ok
        </v-btn>
    </v-card-actions>
    </v-card>

<v-overlay
    opacity="0.3"
    :value="show_loading"
    z-index="10"
>
     <v-progress-circular
      :size="70"
      :width="7"
      color="primary"
      indeterminate
    ></v-progress-circular>
</v-overlay>

 <m-date-picker-dialog
    ref="date-picker"
    :title="date_picker_title"
    v-on:ok="onChooseDate"
    range
 />

</v-dialog>
</template>

<script>

var _ = require('lodash');

export default {
    data() {
        return {
            dialog: false, 

            show_loading: false,
            
            dnd_auto_response_message_patterns: [],
            dnd_monday: [],
            dnd_tuesday: [],
            dnd_wednesday: [],
            dnd_thursday: [],
            dnd_friday: [],
            dnd_saturday: [],
            dnd_sunday: [],
            custom_dnd_settings: [],

            date_picker_title: "Select Date(s)",
            date_picker_index: -1,
        }
    },

    methods: 
    {
        showDialog(profile) 
        {
            this.dialog = true;
            this.show_loading = false;

            this.dnd_auto_response_message_patterns = _.cloneDeep(profile.employee_account.dnd_settings.dnd_auto_response_message_patterns);
            this.dnd_monday = profile.employee_account.dnd_settings.monday.available_intervals;
            this.dnd_tuesday = profile.employee_account.dnd_settings.tuesday.available_intervals;
            this.dnd_wednesday = profile.employee_account.dnd_settings.wednesday.available_intervals;
            this.dnd_thursday = profile.employee_account.dnd_settings.thursday.available_intervals;
            this.dnd_friday = profile.employee_account.dnd_settings.friday.available_intervals;
            this.dnd_saturday = profile.employee_account.dnd_settings.saturday.available_intervals;
            this.dnd_sunday = profile.employee_account.dnd_settings.sunday.available_intervals;
            this.custom_dnd_settings = profile.employee_account.dnd_settings.custom_dnd_settings;
        },

        copyWeekday(src)
        {
            this.dnd_monday = _.cloneDeep(src);
            this.dnd_tuesday = _.cloneDeep(src);
            this.dnd_wednesday = _.cloneDeep(src);
            this.dnd_thursday = _.cloneDeep(src);
            this.dnd_friday = _.cloneDeep(src);

            this.$forceUpdate();
        },

        copyWeekend(src)
        {
           this.dnd_saturday = _.cloneDeep(src);
           this.dnd_sunday = _.cloneDeep(src);
        },

        copyAll(src)
        {
            this.dnd_monday = _.cloneDeep(src);
            this.dnd_tuesday = _.cloneDeep(src);
            this.dnd_wednesday = _.cloneDeep(src);
            this.dnd_thursday = _.cloneDeep(src);
            this.dnd_friday = _.cloneDeep(src);
            this.dnd_saturday = _.cloneDeep(src);
            this.dnd_sunday = _.cloneDeep(src);
        },

        onAddDNDDate()
        {
            this.date_picker_index = -1;

            let date_picker = this.$refs['date-picker'];
            date_picker.showDialog(null); 
        },

        deleteCustomDND(index)
        {
            this.custom_dnd_settings.splice(index,1);
            this.$forceUpdate();
        },

        setCustomAutoReply(index, patterns)
        {
            this.custom_dnd_settings[index].dnd_auto_response_message_patterns = patterns;
            this.$forceUpdate();
        },
        
        onOk()
        {
           this.dialog = false;

           let changes = {

               'dnd_settings' : {
                   dnd_auto_response_message_patterns: this.dnd_auto_response_message_patterns,
                   monday: { 'available_intervals' : this.dnd_monday },
                   tuesday: { 'available_intervals' : this.dnd_tuesday },
                   wednesday: { 'available_intervals' : this.dnd_wednesday },
                   thursday: { 'available_intervals' : this.dnd_thursday },
                   friday: { 'available_intervals' : this.dnd_friday },
                   saturday: { 'available_intervals' : this.dnd_saturday },
                   sunday: { 'available_intervals' : this.dnd_sunday },

                   'custom_dnd_settings' : this.custom_dnd_settings,
               }
           };

            this.$emit('ok', changes);
        },

        prettyDateRange(custom_dnd)
        {
            if (custom_dnd.start_date == custom_dnd.stop_date)
                return custom_dnd.start_date;
            
            return custom_dnd.start_date+" thru "+custom_dnd.stop_date;
        },

        onEditDates(index)
        {
            this.date_picker_index = this.date_picker_index = index;
            let cur = this.custom_dnd_settings[index];

            let date_picker = this.$refs['date-picker'];
            date_picker.showDialog([cur.start_date,cur.stop_date]); 
        },

        onChooseDate(dates)
        {
            if ( dates.length == 0 ) return;

            if ( this.date_picker_index == -1 )
            {
                // Add a new date range
                if ( dates.length == 1 )
                {
                    // add (all on one date though...)
                    this.custom_dnd_settings.push({
                        'start_date' : dates[0],
                        'stop_date' : dates[0],
                        'available_intervals' : ["8:00 AM - 8:00 PM"],
                    });
                }

                if ( dates.length == 2 )
                {
                    // add
                    this.custom_dnd_settings.push({
                        'start_date' : this.minDate(dates[0], dates[1]),
                        'stop_date' : this.maxDate(dates[0], dates[1]),
                        'available_intervals' : ["8:00 AM - 8:00 PM"],
                    });
                }
            }
            else
            {
                // set existing dates
                if ( dates.length == 1 )
                {
                    // add (all on one date though...)
                    this.custom_dnd_settings[this.date_picker_index].start_date = dates[0];
                    this.custom_dnd_settings[this.date_picker_index].stop_date = dates[0];
                }

                if ( dates.length == 2 )
                {
                    // add
                     this.custom_dnd_settings[this.date_picker_index].start_date = this.minDate(dates[0], dates[1]);
                    this.custom_dnd_settings[this.date_picker_index].stop_date = this.maxDate(dates[0], dates[1]);
                }
            }
        },

        minDate(one,two)
        {
            if ( one < two ) return one;
            return two;
        },

        maxDate(one,two)
        {
            if ( one > two ) return one;
            return two;
        },
    },
}
</script>

<style lang="scss" scoped>

</style>